import { render } from "./RelationCollection.vue?vue&type=template&id=6e7d364c"
import script from "./RelationCollection.vue?vue&type=script&lang=js"
export * from "./RelationCollection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__